// extracted by mini-css-extract-plugin
module.exports = {"countdown":"Cf","srOnly":"Df"};